const dataMPRcolors = {
  bleue: {
    bg: '#4CAFE6',
    label: 'très modestes',
  },
  rose: {
    bg: '#E7A1AA',
    label: 'supérieurs',
  },
  violette: {
    bg: '#8D86BB',
    label: 'intermédiaires',
  },
  jaune: {
    bg: '#F7D173',
    label: 'modestes',
  },
};

export default dataMPRcolors;
